import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ad5a7b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Login" }
const _hoisted_2 = { class: "Login_Container" }
const _hoisted_3 = { class: "Login_Wrapper" }
const _hoisted_4 = { class: "Login_Form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Login_Form_Title" }, "ログイン", -1))
const _hoisted_6 = { class: "error_message" }
const _hoisted_7 = { class: "error_message" }

import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import BtnGreen from "../components/atoms/button/BtnGreen.vue";
import InputText from "../components/atoms/Input/InputText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const router = useRouter();
const store = useStore();
emit("toggleGlobalHeader");

const setBaseUrl = () => {
  store.commit("setBaseUrl");
};
setBaseUrl();

//ログイン--------------------------------------
const login = async () => {
  validateError();
  if (hasError.value === false) {
    const postData = {
      email: mailAddress.value,
      password: password.value,
    };
    const res = await store.dispatch("login/login", postData);

    if (res) {
      hasError.value = true;
      if (res.includes("username")) {
        errorMessage.email = "メールアドレスが正しくありません";
      }
      if (res.includes("password")) {
        errorMessage.password = "パスワードが正しくありません";
      }
    } else {
      try {
        await store.dispatch("login/validateToken");
        await getListData();
        router.push("/dashboard");
      } catch (error) {
        alert("ログイン処理に失敗しました");
        console.log(error);
      }
    }
  }
};
// 各リスト取得
const getListData = async () => {
  const isValidToken = store.getters["login/getIsValidToken"];

  const fetchAllList = async () => {
    await store.dispatch("constant/fetchToritugiList");
    await store.dispatch("constant/fetchSyubetuList");
    await store.dispatch("constant/fetchCategoryList");
    await store.dispatch("constant/fetchEventList");
    await store.dispatch("constant/fetchSalesList");
    await store.dispatch("constant/fetchTorihikiList");
    await store.dispatch("constant/fetchInputUserList");
    await store.dispatch("constant/fetchZaikoStatusList");
    await store.dispatch("constant/fetchEventHenpinDenpyouList");
    await store.dispatch("constant/fetchEventNouhinDenpyouList");
  };
  if (isValidToken) {
    fetchAllList();
  }
};

let mailAddress = ref("");
let password = ref("");
const mailInput = (e: string) => {
  mailAddress.value = e;
};
const passInput = (e: string) => {
  password.value = e;
};

let hasError = ref(false);
let errorMessage = reactive({
  email: "",
  password: "",
});
const validateError = () => {
  hasError.value = false;
  errorMessage.email = "";
  errorMessage.password = "";
  if (mailAddress.value === "") {
    errorMessage.email = "メールアドレスを入力してください";
    hasError.value = true;
  }
  if (password.value === "") {
    errorMessage.password = "パスワードを入力してください";
    hasError.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(InputText, {
            class: "Login_Form_Input",
            placeholder: "メールアドレス",
            onOnInput: mailInput
          }),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(errorMessage).email), 1),
          _createVNode(InputText, {
            class: "Login_Form_Input",
            placeholder: "パスワード",
            type: "password",
            onOnInput: passInput
          }),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(errorMessage).password), 1),
          _createVNode(BtnGreen, {
            class: "Login_Form_BtnGreen",
            onClick: login
          }, {
            default: _withCtx(() => [
              _createTextVNode("ログイン")
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createTextVNode(" パスワードを忘れた方は "),
            _createElementVNode("a", null, [
              _createVNode(_component_router_link, { to: "/passwordForget" }, {
                default: _withCtx(() => [
                  _createTextVNode("こちら")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})